import { Box, List, Typography, ListItem } from "@mui/material";
import React from "react";
import data from "../../Assets/data/journalarticles.json";

const ArticlesSection = React.forwardRef((props, ref) => {
  return (
    <>
      <Box ref={ref}>
        <Typography
          style={{ margin: "24px 0px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Journal Articles
        </Typography>
        <List>
          {data.map((article, i) => {
            return (
              <ListItem
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography fontWeight={600} fontSize="18px">
                  {article.title}
                </Typography>
                <Typography>{article.authors}</Typography>
                <Typography fontSize="14px">{article.year}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
});

export default ArticlesSection;
